import React from "react";
import { TaskPPC } from "./TaskPPC";
import { TaskReason } from "./TaskReason";
import { TaskStatus } from "./TaskStatus";

export type ReportType = "status" | "ppc" | "reason";

export type ReportFactoryProps = {
  type: ReportType;
};
export const ReportFactory = ({ type }: ReportFactoryProps) => {
  switch (type) {
    case "status":
      return <TaskStatus />;
    case "ppc":
      return <TaskPPC />;
    case "reason":
      return <TaskReason />;
    default:
      return null;
  }
};
